import Alpine from 'alpinejs';
import Swiper from 'swiper/bundle';
import ajax from '@imacrayon/alpine-ajax';
import htmx from 'htmx.org';
import persist from '@alpinejs/persist';
import resize from '@alpinejs/resize';
import focus from '@alpinejs/focus';
import lightModeDarkMode from './lightmode-darkmode.js';

// Register Alpine AJAX plugin
Alpine.plugin(ajax);
Alpine.plugin(persist);
Alpine.plugin(resize);
Alpine.plugin(focus);

window.Alpine = Alpine;
window.htmx = htmx;
window.Swiper = Swiper;

Alpine.data('lightModeDarkMode', lightModeDarkMode);

// Configure Alpine AJAX with WordPress nonce
document.addEventListener('alpine:init', () => {
    const wpNonce = window.wpApiSettings?.nonce || window.nonce;
    
    if (wpNonce) {
        // Configure Alpine AJAX headers
        Alpine.store('ajax', {
            headers: {
                'X-WP-Nonce': wpNonce,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
});

// Configure HTMX if nonce is available
const wpNonce = window.wpApiSettings?.nonce || window.nonce;
if(wpNonce) {
    document.addEventListener('htmx:configRequest', function(event) {
        event.detail.headers['X-WP-Nonce'] = wpNonce;
    });
}

document.addEventListener('DOMContentLoaded', function() {
    Alpine.start();
});

// Alpine.magic('blockData', (el, { Alpine }) => {
//     // el.parentElement.id is the key of the blockData object
//     let blockData = Alpine.store('blockData')[el.parentElement.id];
//     return blockData;
// });